var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.audio)?_c('audio',{ref:"media",attrs:{"autoplay":""},domProps:{"srcObject":_vm.stream},on:{"loadedmetadata":_vm.play}}):_c('video',{ref:"media",class:{'chat-call-media--mirror':_vm.mirror},attrs:{"autoplay":"","playsinline":""},domProps:{"srcObject":_vm.stream,"muted":_vm.muted},on:{"loadedmetadata":_vm.play}})
}
var staticRenderFns = []

export { render, staticRenderFns }